import {Injectable} from '@angular/core';
import {Network} from "@ionic-native/network";
import {Subscription} from 'rxjs/Subscription';
import {AlertController, Events, Platform} from "ionic-angular";
import { OpenNativeSettings } from '@ionic-native/open-native-settings';
/*
  Generated class for the NetworkServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

export enum ConnectionStatusEnum {
  Online,
  Offline
}

@Injectable()
export class NetworkService {

  networkChange: Subscription;

  networkStatus: any;

  networkConnected: Subscription;
  networkDisconnected: Subscription;


  constructor(public network: Network,
              public alertCtrl: AlertController,
              private openNativeSettings: OpenNativeSettings,
              public pltform: Platform,
              public eventCtrl: Events) {
    this.networkStatus = ConnectionStatusEnum.Online;
  }

  addNetworkDetector(): void {
    this.network.onDisconnect().subscribe(() => {
      if (this.networkStatus === ConnectionStatusEnum.Online) {
        setTimeout(() => {
          if (this.network.type == 'none') {
            this.eventCtrl.publish('network:offline');
          }
        }, 500);

      }
      this.networkStatus = ConnectionStatusEnum.Offline;
    });



    this.network.onConnect().subscribe(() => {
      if (this.networkStatus === ConnectionStatusEnum.Offline) {
        setTimeout(() => {
          if (this.network.type !== 'none') {
            this.eventCtrl.publish('network:online');
          }
        });
      }
      this.networkStatus = ConnectionStatusEnum.Online;
    });
  }



  // network checking
  checkConnection() {
    //unknown, ethernet, wifi, 2g, 3g, 4g, cellular, none
    let networkState = this.network.type;
    console.log('Init: NETWORK CHECKING');
    console.log(networkState);
    if (networkState == '2g' || networkState == 'unknown' || networkState == 'none') {
      //网络状态不好
      // this.noticeSer.showMsg('当前网络状态不佳，已启用节流模式');
      this.networkStatus = ConnectionStatusEnum.Offline;
      this.showNetworkAlert();
    }
  }


  showNetworkAlert() {
    let alert = this.alertCtrl.create({
      title: '无网络可用',
      message: '请检查是否已允许overdose链接网络',
      buttons: [
        {
          text: '知道了',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: '去检查',
          handler: () => {
            console.log('跳转到网络设置');
            // ios && android same
            this.openNativeSettings.open('application_details').then(data => {
              console.log('跳转到网络设置成功');
            }).catch(err => {
              console.log('openNativeSettingsTest is not active!');
            })
          }
        }
      ]
    });
    alert.present();
  }

  removeNetworkDetector() {
    this.networkConnected.unsubscribe();
    this.networkDisconnected.unsubscribe();
  }

}

/**
 addNetworkConnectedDetector() {
    this.networkConnected = this.network.onConnect().subscribe(data => {
      console.log('networkConnected');
      console.log(data);
      // AppConfig.IS_ONLINE = 1;
      // console.log(AppConfig.IS_ONLINE);

      // this.showNetworkAlert();
    }, error => console.error(error));

  }

 addNetworkDisConnectedDetector() {
    this.networkDisconnected = this.network.onDisconnect().subscribe(data => {
      console.log('networkDisconnected');
      console.log(this.network.type);
      console.log(data);
      // AppConfig.IS_ONLINE = 0;
      // console.log(AppConfig.IS_ONLINE);

      this.showNetworkAlert();
    }, error => console.error(error));
  }

 addNetworkChangeDetector() {
    this.networkChange = this.network.onchange().subscribe(data => {
      console.log('addNetworkChangeDetector');
      console.log(this.network.type);
      console.log(data);
    }, error => {
      console.error(error);
    });
  }
 */



// WEBPACK FOOTER //
// ./src/providers/api-service/network-service.ts